import { render } from "./SingleSaleForSixCatalogy.vue?vue&type=template&id=98b19088&scoped=true"
import script from "./SingleSaleForSixCatalogy.vue?vue&type=script&lang=js"
export * from "./SingleSaleForSixCatalogy.vue?vue&type=script&lang=js"

import "./SingleSaleForSixCatalogy.vue?vue&type=style&index=0&id=98b19088&scoped=true&lang=css"

import exportComponent from "C:\\Users\\מפתח רוסמן\\Desktop\\Projects\\RosmanNext\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98b19088"]])

export default __exports__